//@flow

//
// Here we store font configs from https://icomoon.io/app/. 
// Basically there are some json files which maps an icon name with a svg code.
//
import cockpitConfig from "./cockpit-config.json";
export { cockpitConfig };